import _ from 'lodash'
import qs from 'qs';
import { Notifier } from '@airbrake/browser';

export const getPaginationFromMeta = (initial, currentPage, links) => {
  if(links === undefined || Object.keys(links).length === 0) {
    return null;
  }

  const lastPage = links.last;

  let page = currentPage;
  if (lastPage) {
    page = qs.parse(lastPage.split('?')[1]).page;
  } else {
    page = qs.parse(links.self.split('?')[1]).page;
  }
  return page;
};

export function sanitizeURL(url) {
  const a = document.createElement('a');
  a.href = url;
  return a.protocol === 'http:' || a.protocol === 'https:' ? a.href : '';
}

export const toInt = (integer) => {
  return parseInt(String(integer), 10);
}
export const dateFormatUK = (input) => {
  const date = new Date(input);
  let month = date.getMonth();
  let day = date.getDate();
  const year = date.getFullYear();

  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;

  return [day, month, year].join('/');
};

export const dateTimeFormat = (dateString) => {
  if(dateString){
    const date = new Date(dateString);

    return [date.toLocaleDateString('en-GB'), date.toLocaleTimeString('en-GB')].join(' ');
  }
};

export const dateFormat = (dateString) => {
  if(dateString){
    const date = new Date(dateString);

    return date.toLocaleDateString('en-GB');
  }
};

export const ucfirst = (string) => {
  return string.charAt(0).toUpperCase() + string.substr(1);
};

export const deepSearch = (selector, obj) => {
  let p = selector.split('.');
  let len = p.length;
  for (let i = 0; i < len - 1; i++)
    obj = obj[p[i]];

  return obj[p[len - 1]];
};

export const destandard = (responseData) => {
    if(responseData && (typeof responseData === 'object')) {
      let nonStandardObject = {};

      Object.keys(responseData).forEach(oldKey => {
        const newKey = oldKey.split('-').join('_');

        nonStandardObject[newKey] = responseData[oldKey];
      });

      return nonStandardObject;
    }

    return responseData;
};


export const createArray = (obj) => {
  return Object.keys(obj).map((curr, index) => {
    return obj[curr];
  });
};

export const stringToSnakeCase = (str) => str.replace(/[^a-z0-9]/gi, '_').toLowerCase();

// Extracted from RRF
export const isRrfFormValid = (formState) => {
  const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { async: true };

  if (!formState) return true;

  if (!formState.$form) {
    const errors = formState.errors;

    if (!Array.isArray(errors) && !_.isPlainObject(errors)) {
      // If asyncKeys = true and the error is not an
      // array or object (e.g. string), form errors are entirely async
      // and should be ignored when async = true.
      return !options.async && formState.asyncKeys || !errors;
    }

    return Object.keys(formState.errors).every(function (errorKey) {
      // if specified to ignore async validator keys and
      // current error key is an async validator key,
      // treat key as valid
      if (!options.async && Array.isArray(formState.asyncKeys) && !!~formState.asyncKeys.indexOf(errorKey)) {
        return true;
      }

      return !formState.errors[errorKey];
    });
  }

  return Object.keys(formState).every(function (key) {
    return isRrfFormValid(formState[key], options);
  });
};

export const clearString = (string) => string.replace(/\W/g, '').toLowerCase();

export const airbrakeNotifier = new Notifier({
  projectId: process.env.REACT_APP_AIRBRAKE_PROJECT_ID,
  projectKey: process.env.REACT_APP_AIRBRAKE_PROJECT_KEY,
  environment: process.env.REACT_APP_AIRBRAKE_ENV || 'unknown-env'
});



// WEBPACK FOOTER //
// ./src/utils/commonFunctions.js